<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center gap-1 bg-gray-50 text-center"
  >
    <h4
      v-t="'messages.error.mediaclip.title'"
      class="text-2xl font-bold text-gray-600 md:mb-3 md:text-4xl"
    />

    <em
      v-t="'messages.error.mediaclip.body'"
      class="text-xl font-light italic text-slate-900 md:text-2xl"
    />

    <DefaultButton
      class="mt-2 max-w-md bg-green-600 px-4 py-2 text-white hover:bg-green-700 active:bg-green-700"
      @click="resetData"
    >
      <template #default>
        {{ $t('messages.error.mediaclip.refresh') }}
      </template>

      <template #icon>
        <RefreshIcon
          :class="{ 'animate-[spin_500ms]': reloading }"
          class="h-6 w-6"
        />
      </template>
    </DefaultButton>
  </div>
</template>

<script setup lang="ts">
import DefaultButton from '@/components/Buttons/DefaultButton.vue';
import RefreshIcon from '@/components/Icons/RefreshIcon.vue';
import { ref } from 'vue';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';

const configuratorStore = useConfiguratorStore();
const reloading = ref(false);

function resetData(): void {
  reloading.value = true;
  configuratorStore.resetData();
}
</script>
